import React from 'react';
import Select from 'components/select/select';
import { useRouter } from 'next/router';
import { SupportedLanguage } from 'lib/lexemes/supported-languages';
import LocaleContext from 'lib/locale-context';
import footer from 'components/lexemes/footer';

type Props = {
    onChange?: (value: string) => void;
};

const SUPPORTED_LANGUAGE_LIST: Array<{ value: SupportedLanguage; title: string }> = [
    {
        value: 'en',
        title: 'English',
    },
    {
        value: 'fr',
        title: 'Français',
    },
    {
        value: 'de',
        title: 'Deutsch',
    },
    {
        value: 'pt',
        title: 'Português',
    },
    {
        value: 'es',
        title: 'Español',
    },
    {
        value: 'ru',
        title: 'Русский',
    },
];

const LanguageSelector: React.FC<Props> = () => {
    const router = useRouter();
    const { basePath, query } = router;
    const lang = React.useContext(LocaleContext);

    const handleChange = (langId: string) => {
        // @ts-ignore
        window.location = `${basePath}/${langId}/${query.all ? query.all.join('/') : ''}`;
    };

    const languagesList = React.useMemo(() => {
        return SUPPORTED_LANGUAGE_LIST.map(({ value, title }) => ({
            value,
            title,
            href: `${basePath}/${value}/`,
        }));
    }, [basePath]);

    return (
        <Select
            onChange={(value) => handleChange(value)}
            defaultValue={lang}
            options={languagesList}
            a11y={{
                label: footer.lxLanguageSelection(),
            }}
        />
    );
};

export default LanguageSelector;
